export default __webpack_public_path__ + "static/media/cool.b9bbc88b.png";